<template lang="pug">
  svg(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 57.27 89.34")
    defs
      linearGradient(
        id="gradient_4" x1="31.07" y1="-4.94" x2="31.07" y2="22.25"
        gradientTransform="matrix(1, 0, 0, -1, 0, 45.54)" gradientUnits="userSpaceOnUse"
      )
        stop(offset="0" stop-color="#5a7a00")
        stop(offset="1" stop-color="#344b00")
      linearGradient(id="gradient_4-2" x1="28.64" y1="-36.96" x2="28.64" y2="-22.79" xlink:href="#gradient_4")
      linearGradient(id="gradient_4-3" x1="30.34" y1="-23.18" x2="30.34" y2="0.12" xlink:href="#gradient_4")
      linearGradient(id="gradient_4-4" x1="31.79" y1="12.77" x2="31.79" y2="39.09" xlink:href="#gradient_4")
      linearGradient(
        id="gradient_8" x1="28.46" y1="26.41" x2="28.46" y2="29.09"
        gradientTransform="matrix(1, 0, 0, -1, 0, 45.54)" gradientUnits="userSpaceOnUse"
      )
        stop(offset="0" stop-color="#fff")
        stop(offset="1" stop-color="#344b00")
      linearGradient(id="gradient_8-2" x1="26.13" y1="5.41" x2="26.13" y2="12.98" xlink:href="#gradient_8")
      linearGradient(id="gradient_8-3" x1="23.54" y1="-15.99" x2="23.54" y2="-7.06" xlink:href="#gradient_8")
      linearGradient(id="gradient_8-4" x1="20.05" y1="-37.17" x2="20.05" y2="-24.9" xlink:href="#gradient_8")
      linearGradient(
        id="gradient_18" x1="28.33" y1="27.15" x2="28.33" y2="36.55"
        gradientTransform="matrix(1, 0, 0, -1, 0, 45.54)" gradientUnits="userSpaceOnUse"
      )
        stop(offset="0" stop-color="#5a7a00")
        stop(offset="1" stop-color="#759c00")
      linearGradient(id="gradient_18-2" x1="27.61" y1="6.47" x2="27.61" y2="23.7" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-3" x1="26.88" y1="-14.65" x2="26.88" y2="6.47" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-4" x1="26.15" y1="-35.76" x2="26.15" y2="-10.76" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-5" x1="42.08" y1="-42.42" x2="42.08" y2="-29.93" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-6" x1="26.98" y1="27.15" x2="26.98" y2="36.55" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-7" x1="25.47" y1="6.47" x2="25.47" y2="23.7" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-8" x1="24.75" y1="-14.65" x2="24.75" y2="6.47" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-9" x1="24.03" y1="-35.76" x2="24.03" y2="-10.76" xlink:href="#gradient_18")
      linearGradient(id="gradient_18-10" x1="40.83" y1="-42.42" x2="40.83" y2="-29.93" xlink:href="#gradient_18")

    g(id="Слой_2" data-name="Слой 2")
      g(id="Слой_1-2" data-name="Слой 1")
        polygon(class="cls-1" points="45.38 53.48 16.75 40.97 18.03 37.66 22.04 27.37 30.11 33.7 35.5 37.92 41.01 42.24 45.38 53.48")
        polygon(class="cls-2" points="57.27 84.06 0 84.06 2.61 77.35 5.29 70.46 18.37 72.28 40.09 75.31 54.65 77.34 57.27 84.06")
        polygon(class="cls-3" points="52.3 71.29 8.37 62.52 13.66 48.91 29.14 53.94 38.7 57.05 47.93 60.05 52.3 71.29")
        polygon(class="cls-4" points="25.12 19.43 38.46 35.67 34.08 24.43 28.63 10.4 25.12 19.43")
        polygon(class="cls-5" points="31.14 16.85 25.12 19.43 31.8 18.55 31.14 16.85")
        polygon(class="cls-6" points="16.75 40.97 35.5 37.92 30.11 33.7 18.03 37.66 16.75 40.97")
        polygon(class="cls-7" points="38.7 57.05 8.37 62.52 29.14 53.94 38.7 57.05")
        polygon(class="cls-8" points="40.09 75.31 0 84.06 2.61 77.35 18.37 72.28 40.09 75.31")
        polygon(class="cls-9" points="31.53 17.86 25.12 19.43 28.63 10.4 31.53 17.86")
        polygon(class="cls-10" points="38.46 35.67 16.75 40.97 22.04 27.37 34.08 24.43 38.46 35.67")
        polygon(class="cls-11" points="45.38 53.48 8.37 62.52 13.66 48.91 41.01 42.24 45.38 53.48")
        polygon(class="cls-12" points="52.3 71.29 0 84.06 5.29 70.46 47.93 60.04 52.3 71.29")
        polygon(class="cls-13" points="57.27 84.06 26.88 89.34 54.65 77.34 57.27 84.06")

        g(class="cls-14")
          polygon(class="cls-15" points="28.84 10.92 28.63 10.4 25.12 19.43 25.57 19.32 28.84 10.92")
          polygon(class="cls-16" points="22.35 27.62 34.2 24.72 34.08 24.43 22.04 27.37 16.75 40.97 17.2 40.86 22.35 27.62")
          polygon(class="cls-17" points="13.97 49.16 41.12 42.53 41.01 42.24 13.66 48.91 8.37 62.52 8.82 62.41 13.97 49.16")
          polygon(class="cls-18" points="5.6 70.71 48.05 60.34 47.93 60.04 5.29 70.46 0 84.06 0.45 83.95 5.6 70.71")
          polygon(class="cls-19" points="54.78 77.67 54.65 77.34 26.88 89.34 28.36 89.08 54.78 77.67")

        g(class="star")
          polygon(class="cls-20" points="28.56 0 28.56 9.71 27.35 6.96 24.35 7.28 26.13 4.85 24.35 2.43 27.35 2.75 28.56 0")
          polygon(class="cls-21" points="30.99 4.85 32.77 7.28 29.77 6.96 28.56 9.71 28.56 0 29.77 2.75 32.77 2.43 30.99 4.85")

        path(class="cls-22" d="M23.46,28.16a.42.42,0,1,1-.42-.42A.42.42,0,0,1,23.46,28.16Z")
        path(class="cls-22" d="M37.62,34.89a.42.42,0,1,1-.42-.42A.42.42,0,0,1,37.62,34.89Z")
        path(class="cls-22" d="M15,50.14a.42.42,0,1,1-.42-.42A.41.41,0,0,1,15,50.14Z")
        path(class="cls-22" d="M44.22,52.79a.42.42,0,1,1-.42-.42A.42.42,0,0,1,44.22,52.79Z")
        path(class="cls-22" d="M51.44,71a.42.42,0,1,1-.42-.42A.41.41,0,0,1,51.44,71Z")
        circle(class="cls-22" cx="56.01" cy="83.34" r="0.42")
        path(class="cls-22" d="M6.44,71.29A.42.42,0,1,1,6,70.87.42.42,0,0,1,6.44,71.29Z")
        path(class="cls-22" d="M30.92,17.16a.42.42,0,1,1-.42-.42A.42.42,0,0,1,30.92,17.16Z")
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: url(#gradient_4);
}
.cls-2 {
  fill: url(#gradient_4-2);
}
.cls-3 {
  fill: url(#gradient_4-3);
}
.cls-4 {
  fill: url(#gradient_4-4);
}
.cls-5 {
  fill: url(#gradient_8);
}
.cls-6 {
  fill: url(#gradient_8-2);
}
.cls-7 {
  fill: url(#gradient_8-3);
}
.cls-8 {
  fill: url(#gradient_8-4);
}
.cls-9 {
  fill: url(#gradient_18);
}
.cls-10 {
  fill: url(#gradient_18-2);
}
.cls-11 {
  fill: url(#gradient_18-3);
}
.cls-12 {
  fill: url(#gradient_18-4);
}
.cls-13 {
  fill: url(#gradient_18-5);
}
.cls-14 {
  opacity: 0.51;
}
.cls-15 {
  fill: url(#gradient_18-6);
}
.cls-16 {
  fill: url(#gradient_18-7);
}
.cls-17 {
  fill: url(#gradient_18-8);
}
.cls-18 {
  fill: url(#gradient_18-9);
}
.cls-19 {
  fill: url(#gradient_18-10);
}
.cls-20 {
  fill: #e30613;
}
.cls-21 {
  fill: #e94e1b;
}
.cls-22 {
  fill: #d7ffa2;
}

.star {
  animation: star 2s infinite;
  transform-origin: center;
  transform-box: fill-box;
}

@keyframes star {
  0% {
    transform: scale(1) translate(0px, 0px);
    opacity: 1;
  }
  25% {
    transform: translate(0px, 25%);
  }
  50% {
    transform: scale(3) translate(0, 25%);
    opacity: 0.8;
  }
  75% {
    transform: translate(0px, 25%)
  }
  100% {
    transform: scale(1) translate(0px, 0px);
    opacity: 1;
  }
}
</style>
